export const COUNTRIES = [
  {
    "name": "Afghanistan",
    "dial": "+93",
    "flag": "🇦🇫"
  },
  {
    "name": "Albania",
    "dial": "+355",
    "flag": "🇦🇱"
  },
  {
    "name": "Algeria",
    "dial": "+213",
    "flag": "🇩🇿"
  },
  {
    "name": "American Samoa",
    "dial": "+1 684",
    "flag": "🇦🇸"
  },
  {
    "name": "Andorra",
    "dial": "+376",
    "flag": "🇦🇩"
  },
  {
    "name": "Angola",
    "dial": "+244",
    "flag": "🇦🇴"
  },
  {
    "name": "Anguilla",
    "dial": "+1 264",
    "flag": "🇦🇮"
  },
  {
    "name": "Antarctica",
    "dial": "+672",
    "flag": "🇦🇶"
  },
  {
    "name": "Antigua and Barbuda",
    "dial": "+1 268",
    "flag": "🇦🇬"
  },
  {
    "name": "Argentina",
    "dial": "+54",
    "flag": "🇦🇷"
  },
  {
    "name": "Armenia",
    "dial": "+374",
    "flag": "🇦🇲"
  },
  {
    "name": "Aruba",
    "dial": "+297",
    "flag": "🇦🇼"
  },
  {
    "name": "Australia",
    "dial": "+61",
    "flag": "🇦🇺"
  },
  {
    "name": "Austria",
    "dial": "+43",
    "flag": "🇦🇹"
  },
  {
    "name": "Azerbaijan",
    "dial": "+994",
    "flag": "🇦🇿"
  },
  {
    "name": "Bahamas",
    "dial": "+1 242",
    "flag": "🇧🇸"
  },
  {
    "name": "Bahrain",
    "dial": "+973",
    "flag": "🇧🇭"
  },
  {
    "name": "Bangladesh",
    "dial": "+880",
    "flag": "🇧🇩"
  },
  {
    "name": "Barbados",
    "dial": "+1 246",
    "flag": "🇧🇧"
  },
  {
    "name": "Belarus",
    "dial": "+375",
    "flag": "🇧🇾"
  },
  {
    "name": "Belgium",
    "dial": "+32",
    "flag": "🇧🇪"
  },
  {
    "name": "Belize",
    "dial": "+501",
    "flag": "🇧🇿"
  },
  {
    "name": "Benin",
    "dial": "+229",
    "flag": "🇧🇯"
  },
  {
    "name": "Bermuda",
    "dial": "+1 441",
    "flag": "🇧🇲"
  },
  {
    "name": "Bhutan",
    "dial": "+975",
    "flag": "🇧🇹"
  },
  {
    "name": "Bolivia",
    "dial": "+591",
    "flag": "🇧🇴"
  },
  {
    "name": "Bonaire",
    "dial": "+5997",
    "flag": "🇧🇶"
  },
  {
    "name": "Bosnia and Herzegovina",
    "dial": "+387",
    "flag": "🇧🇦"
  },
  {
    "name": "Botswana",
    "dial": "+267",
    "flag": "🇧🇼"
  },
  {
    "name": "Bouvet Island",
    "dial": "+47",
    "flag": "🇧🇻"
  },
  {
    "name": "Brazil",
    "dial": "+55",
    "flag": "🇧🇷"
  },
  {
    "name": "British Indian Ocean Territory",
    "dial": "+246",
    "flag": "🇮🇴"
  },
  {
    "name": "British Virgin Islands",
    "dial": "+1 284",
    "flag": "🇻🇬"
  },
  {
    "name": "Brunei",
    "dial": "+673",
    "flag": "🇧🇳"
  },
  {
    "name": "Bulgaria",
    "dial": "+359",
    "flag": "🇧🇬"
  },
  {
    "name": "Burkina Faso",
    "dial": "+226",
    "flag": "🇧🇫"
  },
  {
    "name": "Burundi",
    "dial": "+257",
    "flag": "🇧🇮"
  },
  {
    "name": "Cambodia",
    "dial": "+855",
    "flag": "🇰🇭"
  },
  {
    "name": "Cameroon",
    "dial": "+237",
    "flag": "🇨🇲"
  },
  {
    "name": "Canada",
    "dial": "+1",
    "flag": "🇨🇦"
  },
  {
    "name": "Cape Verde",
    "dial": "+238",
    "flag": "🇨🇻"
  },
  {
    "name": "Cayman Islands",
    "dial": "+1 345",
    "flag": "🇰🇾"
  },
  {
    "name": "Central African Republic",
    "dial": "+236",
    "flag": "🇨🇫"
  },
  {
    "name": "Chad",
    "dial": "+235",
    "flag": "🇹🇩"
  },
  {
    "name": "Chile",
    "dial": "+56",
    "flag": "🇨🇱"
  },
  {
    "name": "China",
    "dial": "+86",
    "flag": "🇨🇳"
  },
  {
    "name": "Christmas Island",
    "dial": "+61",
    "flag": "🇨🇽"
  },
  {
    "name": "Cocos [Keeling] Islands",
    "dial": "+61",
    "flag": "🇨🇨"
  },
  {
    "name": "Colombia",
    "dial": "+57",
    "flag": "🇨🇴"
  },
  {
    "name": "Comoros",
    "dial": "+269",
    "flag": "🇰🇲"
  },
  {
    "name": "Cook Islands",
    "dial": "+682",
    "flag": "🇨🇰"
  },
  {
    "name": "Costa Rica",
    "dial": "+506",
    "flag": "🇨🇷"
  },
  {
    "name": "Croatia",
    "dial": "+385",
    "flag": "🇭🇷"
  },
  {
    "name": "Cuba",
    "dial": "+53",
    "flag": "🇨🇺"
  },
  {
    "name": "Curacao",
    "dial": "+5999",
    "flag": "🇨🇼"
  },
  {
    "name": "Cyprus",
    "dial": "+357",
    "flag": "🇨🇾"
  },
  {
    "name": "Czech Republic",
    "dial": "+420",
    "flag": "🇨🇿"
  },
  {
    "name": "Democratic Republic of the Congo",
    "dial": "+243",
    "flag": "🇨🇩"
  },
  {
    "name": "Denmark",
    "dial": "+45",
    "flag": "🇩🇰"
  },
  {
    "name": "Djibouti",
    "dial": "+253",
    "flag": "🇩🇯"
  },
  {
    "name": "Dominica",
    "dial": "+1 767",
    "flag": "🇩🇲"
  },
  {
    "name": "Dominican Republic",
    "dial": "+1 809",
    "flag": "🇩🇴"
  },
  {
    "name": "East Timor",
    "dial": "+670",
    "flag": "🇹🇱"
  },
  {
    "name": "Ecuador",
    "dial": "+593",
    "flag": "🇪🇨"
  },
  {
    "name": "Egypt",
    "dial": "+20",
    "flag": "🇪🇬"
  },
  {
    "name": "El Salvador",
    "dial": "+503",
    "flag": "🇸🇻"
  },
  {
    "name": "Equatorial Guinea",
    "dial": "+240",
    "flag": "🇬🇶"
  },
  {
    "name": "Eritrea",
    "dial": "+291",
    "flag": "🇪🇷"
  },
  {
    "name": "Estonia",
    "dial": "+372",
    "flag": "🇪🇪"
  },
  {
    "name": "Ethiopia",
    "dial": "+251",
    "flag": "🇪🇹"
  },
  {
    "name": "Falkland Islands",
    "dial": "+500",
    "flag": "🇫🇰"
  },
  {
    "name": "Faroe Islands",
    "dial": "+298",
    "flag": "🇫🇴"
  },
  {
    "name": "Fiji",
    "dial": "+679",
    "flag": "🇫🇯"
  },
  {
    "name": "Finland",
    "dial": "+358",
    "flag": "🇫🇮"
  },
  {
    "name": "France",
    "dial": "+33",
    "flag": "🇫🇷"
  },
  {
    "name": "French Guiana",
    "dial": "+594",
    "flag": "🇬🇫"
  },
  {
    "name": "French Polynesia",
    "dial": "+689",
    "flag": "🇵🇫"
  },
  {
    "name": "French Southern Territories",
    "dial": "+262",
    "flag": "🇹🇫"
  },
  {
    "name": "Gabon",
    "dial": "+241",
    "flag": "🇬🇦"
  },
  {
    "name": "Gambia",
    "dial": "+220",
    "flag": "🇬🇲"
  },
  {
    "name": "Georgia",
    "dial": "+995",
    "flag": "🇬🇪"
  },
  {
    "name": "Germany",
    "dial": "+49",
    "flag": "🇩🇪"
  },
  {
    "name": "Ghana",
    "dial": "+233",
    "flag": "🇬🇭"
  },
  {
    "name": "Gibraltar",
    "dial": "+350",
    "flag": "🇬🇮"
  },
  {
    "name": "Greece",
    "dial": "+30",
    "flag": "🇬🇷"
  },
  {
    "name": "Greenland",
    "dial": "+299",
    "flag": "🇬🇱"
  },
  {
    "name": "Grenada",
    "dial": "+1 473",
    "flag": "🇬🇩"
  },
  {
    "name": "Guadeloupe",
    "dial": "+590",
    "flag": "🇬🇵"
  },
  {
    "name": "Guam",
    "dial": "+1 671",
    "flag": "🇬🇺"
  },
  {
    "name": "Guatemala",
    "dial": "+502",
    "flag": "🇬🇹"
  },
  {
    "name": "Guernsey",
    "dial": "+44",
    "flag": "🇬🇬"
  },
  {
    "name": "Guinea",
    "dial": "+224",
    "flag": "🇬🇳"
  },
  {
    "name": "Guinea-Bissau",
    "dial": "+245",
    "flag": "🇬🇼"
  },
  {
    "name": "Guyana",
    "dial": "+592",
    "flag": "🇬🇾"
  },
  {
    "name": "Haiti",
    "dial": "+509",
    "flag": "🇭🇹"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "dial": "+61",
    "flag": "🇭🇲"
  },
  {
    "name": "Honduras",
    "dial": "+504",
    "flag": "🇭🇳"
  },
  {
    "name": "Hong Kong",
    "dial": "+852",
    "flag": "🇭🇰"
  },
  {
    "name": "Hungary",
    "dial": "+36",
    "flag": "🇭🇺"
  },
  {
    "name": "Iceland",
    "dial": "+354",
    "flag": "🇮🇸"
  },
  {
    "name": "India",
    "dial": "+91",
    "flag": "🇮🇳"
  },
  {
    "name": "Indonesia",
    "dial": "+62",
    "flag": "🇮🇩"
  },
  {
    "name": "Iran",
    "dial": "+98",
    "flag": "🇮🇷"
  },
  {
    "name": "Iraq",
    "dial": "+964",
    "flag": "🇮🇶"
  },
  {
    "name": "Ireland",
    "dial": "+353",
    "flag": "🇮🇪"
  },
  {
    "name": "Isle of Man",
    "dial": "+44",
    "flag": "🇮🇲"
  },
  {
    "name": "Israel",
    "dial": "+972",
    "flag": "🇮🇱"
  },
  {
    "name": "Italy",
    "dial": "+39",
    "flag": "🇮🇹"
  },
  {
    "name": "Ivory Coast",
    "dial": "+225",
    "flag": "🇨🇮"
  },
  {
    "name": "Jamaica",
    "dial": "+1 876",
    "flag": "🇯🇲"
  },
  {
    "name": "Japan",
    "dial": "+81",
    "flag": "🇯🇵"
  },
  {
    "name": "Jersey",
    "dial": "+44",
    "flag": "🇯🇪"
  },
  {
    "name": "Jordan",
    "dial": "+962",
    "flag": "🇯🇴"
  },
  {
    "name": "Kazakhstan",
    "dial": "+76",
    "flag": "🇰🇿"
  },
  {
    "name": "Kenya",
    "dial": "+254",
    "flag": "🇰🇪"
  },
  {
    "name": "Kiribati",
    "dial": "+686",
    "flag": "🇰🇮"
  },
  {
    "name": "Kosovo",
    "dial": "+377",
    "flag": "🇽🇰"
  },
  {
    "name": "Kuwait",
    "dial": "+965",
    "flag": "🇰🇼"
  },
  {
    "name": "Kyrgyzstan",
    "dial": "+996",
    "flag": "🇰🇬"
  },
  {
    "name": "Laos",
    "dial": "+856",
    "flag": "🇱🇦"
  },
  {
    "name": "Latvia",
    "dial": "+371",
    "flag": "🇱🇻"
  },
  {
    "name": "Lebanon",
    "dial": "+961",
    "flag": "🇱🇧"
  },
  {
    "name": "Lesotho",
    "dial": "+266",
    "flag": "🇱🇸"
  },
  {
    "name": "Liberia",
    "dial": "+231",
    "flag": "🇱🇷"
  },
  {
    "name": "Libya",
    "dial": "+218",
    "flag": "🇱🇾"
  },
  {
    "name": "Liechtenstein",
    "dial": "+423",
    "flag": "🇱🇮"
  },
  {
    "name": "Lithuania",
    "dial": "+370",
    "flag": "🇱🇹"
  },
  {
    "name": "Luxembourg",
    "dial": "+352",
    "flag": "🇱🇺"
  },
  {
    "name": "Macao",
    "dial": "+853",
    "flag": "🇲🇴"
  },
  {
    "name": "Madagascar",
    "dial": "+261",
    "flag": "🇲🇬"
  },
  {
    "name": "Malawi",
    "dial": "+265",
    "flag": "🇲🇼"
  },
  {
    "name": "Malaysia",
    "dial": "+60",
    "flag": "🇲🇾"
  },
  {
    "name": "Maldives",
    "dial": "+960",
    "flag": "🇲🇻"
  },
  {
    "name": "Mali",
    "dial": "+223",
    "flag": "🇲🇱"
  },
  {
    "name": "Malta",
    "dial": "+356",
    "flag": "🇲🇹"
  },
  {
    "name": "Marshall Islands",
    "dial": "+692",
    "flag": "🇲🇭"
  },
  {
    "name": "Martinique",
    "dial": "+596",
    "flag": "🇲🇶"
  },
  {
    "name": "Mauritania",
    "dial": "+222",
    "flag": "🇲🇷"
  },
  {
    "name": "Mauritius",
    "dial": "+230",
    "flag": "🇲🇺"
  },
  {
    "name": "Mayotte",
    "dial": "+262",
    "flag": "🇾🇹"
  },
  {
    "name": "Mexico",
    "dial": "+52",
    "flag": "🇲🇽"
  },
  {
    "name": "Micronesia",
    "dial": "+691",
    "flag": "🇫🇲"
  },
  {
    "name": "Moldova",
    "dial": "+373",
    "flag": "🇲🇩"
  },
  {
    "name": "Monaco",
    "dial": "+377",
    "flag": "🇲🇨"
  },
  {
    "name": "Mongolia",
    "dial": "+976",
    "flag": "🇲🇳"
  },
  {
    "name": "Montenegro",
    "dial": "+382",
    "flag": "🇲🇪"
  },
  {
    "name": "Montserrat",
    "dial": "+1 664",
    "flag": "🇲🇸"
  },
  {
    "name": "Morocco",
    "dial": "+212",
    "flag": "🇲🇦"
  },
  {
    "name": "Mozambique",
    "dial": "+258",
    "flag": "🇲🇿"
  },
  {
    "name": "Myanmar [Burma]",
    "dial": "+95",
    "flag": "🇲🇲"
  },
  {
    "name": "Namibia",
    "dial": "+264",
    "flag": "🇳🇦"
  },
  {
    "name": "Nauru",
    "dial": "+674",
    "flag": "🇳🇷"
  },
  {
    "name": "Nepal",
    "dial": "+977",
    "flag": "🇳🇵"
  },
  {
    "name": "Netherlands",
    "dial": "+31",
    "flag": "🇳🇱"
  },
  {
    "name": "New Caledonia",
    "dial": "+687",
    "flag": "🇳🇨"
  },
  {
    "name": "New Zealand",
    "dial": "+64",
    "flag": "🇳🇿"
  },
  {
    "name": "Nicaragua",
    "dial": "+505",
    "flag": "🇳🇮"
  },
  {
    "name": "Niger",
    "dial": "+227",
    "flag": "🇳🇪"
  },
  {
    "name": "Nigeria",
    "dial": "+234",
    "flag": "🇳🇬"
  },
  {
    "name": "Niue",
    "dial": "+683",
    "flag": "🇳🇺"
  },
  {
    "name": "Norfolk Island",
    "dial": "+672",
    "flag": "🇳🇫"
  },
  {
    "name": "North Korea",
    "dial": "+850",
    "flag": "🇰🇵"
  },
  {
    "name": "North Macedonia",
    "dial": "+389",
    "flag": "🇲🇰"
  },
  {
    "name": "Northern Mariana Islands",
    "dial": "+1 670",
    "flag": "🇲🇵"
  },
  {
    "name": "Norway",
    "dial": "+47",
    "flag": "🇳🇴"
  },
  {
    "name": "Oman",
    "dial": "+968",
    "flag": "🇴🇲"
  },
  {
    "name": "Pakistan",
    "dial": "+92",
    "flag": "🇵🇰"
  },
  {
    "name": "Palau",
    "dial": "+680",
    "flag": "🇵🇼"
  },
  {
    "name": "Palestine",
    "dial": "+970",
    "flag": "🇵🇸"
  },
  {
    "name": "Panama",
    "dial": "+507",
    "flag": "🇵🇦"
  },
  {
    "name": "Papua New Guinea",
    "dial": "+675",
    "flag": "🇵🇬"
  },
  {
    "name": "Paraguay",
    "dial": "+595",
    "flag": "🇵🇾"
  },
  {
    "name": "Peru",
    "dial": "+51",
    "flag": "🇵🇪"
  },
  {
    "name": "Philippines",
    "dial": "+63",
    "flag": "🇵🇭"
  },
  {
    "name": "Pitcairn Islands",
    "dial": "+64",
    "flag": "🇵🇳"
  },
  {
    "name": "Poland",
    "dial": "+48",
    "flag": "🇵🇱"
  },
  {
    "name": "Portugal",
    "dial": "+351",
    "flag": "🇵🇹"
  },
  {
    "name": "Puerto Rico",
    "dial": "+1 787",
    "flag": "🇵🇷"
  },
  {
    "name": "Qatar",
    "dial": "+974",
    "flag": "🇶🇦"
  },
  {
    "name": "Republic of the Congo",
    "dial": "+242",
    "flag": "🇨🇬"
  },
  {
    "name": "Romania",
    "dial": "+40",
    "flag": "🇷🇴"
  },
  {
    "name": "Russia",
    "dial": "+7",
    "flag": "🇷🇺"
  },
  {
    "name": "Rwanda",
    "dial": "+250",
    "flag": "🇷🇼"
  },
  {
    "name": "Réunion",
    "dial": "+262",
    "flag": "🇷🇪"
  },
  {
    "name": "Saint Barthélemy",
    "dial": "+590",
    "flag": "🇧🇱"
  },
  {
    "name": "Saint Helena",
    "dial": "+290",
    "flag": "🇸🇭"
  },
  {
    "name": "Saint Kitts and Nevis",
    "dial": "+1 869",
    "flag": "🇰🇳"
  },
  {
    "name": "Saint Lucia",
    "dial": "+1 758",
    "flag": "🇱🇨"
  },
  {
    "name": "Saint Martin",
    "dial": "+590",
    "flag": "🇲🇫"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "dial": "+508",
    "flag": "🇵🇲"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "dial": "+1 784",
    "flag": "🇻🇨"
  },
  {
    "name": "Samoa",
    "dial": "+685",
    "flag": "🇼🇸"
  },
  {
    "name": "San Marino",
    "dial": "+378",
    "flag": "🇸🇲"
  },
  {
    "name": "Saudi Arabia",
    "dial": "+966",
    "flag": "🇸🇦"
  },
  {
    "name": "Senegal",
    "dial": "+221",
    "flag": "🇸🇳"
  },
  {
    "name": "Serbia",
    "dial": "+381",
    "flag": "🇷🇸"
  },
  {
    "name": "Seychelles",
    "dial": "+248",
    "flag": "🇸🇨"
  },
  {
    "name": "Sierra Leone",
    "dial": "+232",
    "flag": "🇸🇱"
  },
  {
    "name": "Singapore",
    "dial": "+65",
    "flag": "🇸🇬"
  },
  {
    "name": "Sint Maarten",
    "dial": "+1 721",
    "flag": "🇸🇽"
  },
  {
    "name": "Slovakia",
    "dial": "+421",
    "flag": "🇸🇰"
  },
  {
    "name": "Slovenia",
    "dial": "+386",
    "flag": "🇸🇮"
  },
  {
    "name": "Solomon Islands",
    "dial": "+677",
    "flag": "🇸🇧"
  },
  {
    "name": "Somalia",
    "dial": "+252",
    "flag": "🇸🇴"
  },
  {
    "name": "South Africa",
    "dial": "+27",
    "flag": "🇿🇦"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "dial": "+500",
    "flag": "🇬🇸"
  },
  {
    "name": "South Korea",
    "dial": "+82",
    "flag": "🇰🇷"
  },
  {
    "name": "South Sudan",
    "dial": "+211",
    "flag": "🇸🇸"
  },
  {
    "name": "Spain",
    "dial": "+34",
    "flag": "🇪🇸"
  },
  {
    "name": "Sri Lanka",
    "dial": "+94",
    "flag": "🇱🇰"
  },
  {
    "name": "Sudan",
    "dial": "+249",
    "flag": "🇸🇩"
  },
  {
    "name": "Suriname",
    "dial": "+597",
    "flag": "🇸🇷"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "dial": "+4779",
    "flag": "🇸🇯"
  },
  {
    "name": "Swaziland",
    "dial": "+268",
    "flag": "🇸🇿"
  },
  {
    "name": "Sweden",
    "dial": "+46",
    "flag": "🇸🇪"
  },
  {
    "name": "Switzerland",
    "dial": "+41",
    "flag": "🇨🇭"
  },
  {
    "name": "Syria",
    "dial": "+963",
    "flag": "🇸🇾"
  },
  {
    "name": "São Tomé and Príncipe",
    "dial": "+239",
    "flag": "🇸🇹"
  },
  {
    "name": "Taiwan",
    "dial": "+886",
    "flag": "🇹🇼"
  },
  {
    "name": "Tajikistan",
    "dial": "+992",
    "flag": "🇹🇯"
  },
  {
    "name": "Tanzania",
    "dial": "+255",
    "flag": "🇹🇿"
  },
  {
    "name": "Thailand",
    "dial": "+66",
    "flag": "🇹🇭"
  },
  {
    "name": "Togo",
    "dial": "+228",
    "flag": "🇹🇬"
  },
  {
    "name": "Tokelau",
    "dial": "+690",
    "flag": "🇹🇰"
  },
  {
    "name": "Tonga",
    "dial": "+676",
    "flag": "🇹🇴"
  },
  {
    "name": "Trinidad and Tobago",
    "dial": "+1 868",
    "flag": "🇹🇹"
  },
  {
    "name": "Tunisia",
    "dial": "+216",
    "flag": "🇹🇳"
  },
  {
    "name": "Turkey",
    "dial": "+90",
    "flag": "🇹🇷"
  },
  {
    "name": "Turkmenistan",
    "dial": "+993",
    "flag": "🇹🇲"
  },
  {
    "name": "Turks and Caicos Islands",
    "dial": "+1 649",
    "flag": "🇹🇨"
  },
  {
    "name": "Tuvalu",
    "dial": "+688",
    "flag": "🇹🇻"
  },
  {
    "name": "U.S. Minor Outlying Islands",
    "dial": "+1",
    "flag": "🇺🇲"
  },
  {
    "name": "U.S. Virgin Islands",
    "dial": "+1 340",
    "flag": "🇻🇮"
  },
  {
    "name": "Uganda",
    "dial": "+256",
    "flag": "🇺🇬"
  },
  {
    "name": "Ukraine",
    "dial": "+380",
    "flag": "🇺🇦"
  },
  {
    "name": "United Arab Emirates",
    "dial": "+971",
    "flag": "🇦🇪"
  },
  {
    "name": "United Kingdom",
    "dial": "+44",
    "flag": "🇬🇧"
  },
  {
    "name": "United States",
    "dial": "+1",
    "flag": "🇺🇸"
  },
  {
    "name": "Uruguay",
    "dial": "+598",
    "flag": "🇺🇾"
  },
  {
    "name": "Uzbekistan",
    "dial": "+998",
    "flag": "🇺🇿"
  },
  {
    "name": "Vanuatu",
    "dial": "+678",
    "flag": "🇻🇺"
  },
  {
    "name": "Vatican City",
    "dial": "+379",
    "flag": "🇻🇦"
  },
  {
    "name": "Venezuela",
    "dial": "+58",
    "flag": "🇻🇪"
  },
  {
    "name": "Vietnam",
    "dial": "+84",
    "flag": "🇻🇳"
  },
  {
    "name": "Wallis and Futuna",
    "dial": "+681",
    "flag": "🇼🇫"
  },
  {
    "name": "Western Sahara",
    "dial": "+212",
    "flag": "🇪🇭"
  },
  {
    "name": "Yemen",
    "dial": "+967",
    "flag": "🇾🇪"
  },
  {
    "name": "Zambia",
    "dial": "+260",
    "flag": "🇿🇲"
  },
  {
    "name": "Zimbabwe",
    "dial": "+263",
    "flag": "🇿🇼"
  },
  {
    "name": "Åland",
    "dial": "+358",
    "flag": "🇦🇽"
  }
];
